import { useState } from 'react';
import '../../../desktop/InvoicesList/InovicesList.css';

export const FilterDocketOrders = ({ data, setFilteredOrders, filteredOrders }) => {
    const [selectedStatus, setSelectedStatus] = useState('all');

    const filterOrders = (status) => {
        if (status === 'all') {
            setFilteredOrders(data.aufaFlights);
        } else {
            const filtered = Object.entries(data.aufaFlights).reduce((acc, [key, value]) => {
                if (value.status === parseInt(status, 10)) {
                    acc[key] = value;
                }
                return acc;
            }, {});
            setFilteredOrders(filtered);
        }
    };

    const handleStatusChange = (e) => {
        const status = e.target.value;
        setSelectedStatus(status);
        filterOrders(status);
    };

    const renderOrderDetails = (order) => {
        const caData = order.data.ca?.data || [];
        const namesLength = order.data.names?.length || 0;

        return (
            <tr key={order.id}>
                <td>{caData[2] || 'N/A'}</td> {/* תאריך ראשון */}
                <td>{caData[6] && caData[7] ? `${caData[6]} - ${caData[7]}` : 'N/A'}</td> {/* פרטים */}
                <td>{caData[8] || 'N/A'}</td> {/* מס' טיסות */}
                <td>{caData[10] || 'N/A'}</td> {/* מס' נ"פ */}
                <td>{namesLength}</td> {/* מס' נוסעים */}
                <td>{order.data.ca?.price ? `${order.data.ca.price}$` : 'N/A'}</td> {/* סה"כ */}
            </tr>
        );
    };

    return (
        <div>
        <div className='InvoicesListFilter'>
            {/* <p>סטטוס הזמנה</p> */}
            <select value={selectedStatus} onChange={handleStatusChange}>
                <option value="all">כל הסטטוסים</option>
                <option value="0">הזמנה שמורה ל-24 שעות</option>
                <option value="1">הזמנה סגורה</option>
                <option value="2">שולם מראש</option>
                <option value="3">נפל</option>
                <option value="5">הזמנה חדשה</option>
            </select>
            </div>

            <div className='InvoicesListTable'>
                {/* <h3>הזמנות מסוננות</h3> */}
                {Object.entries(filteredOrders).length > 0 ? (
                    <table style={{ backgroundColor: '#f0f0f0' }}>
                        <thead>
                            <tr>
                                <th>תאריך ראשון</th>
                                <th>פרטים</th>
                                <th>מס' טיסות</th>
                                <th>מס' נ"פ</th>
                                <th>מס' נוסעים</th>
                                <th>סה"כ</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(filteredOrders).map(([key, order]) => renderOrderDetails(order))}
                        </tbody>
                    </table>
                ) : (
                    <p>אין תוצאות</p>
                )}
            </div>
        </div>
    );
};

